import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/imgs/qrCode/qrCode1.png'


const _withScopeId = n => (_pushScopeId("data-v-72e949b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "majorEmploymentRankGradeContainer" }
const _hoisted_2 = { class: "majorEmploymentRankGrade" }
const _hoisted_3 = { id: "MajorSituationBackground" }
const _hoisted_4 = { id: "MajorSituationBody" }
const _hoisted_5 = { id: "MajorSituationBodyLeft" }
const _hoisted_6 = {
  key: 1,
  class: "greyBackgroundContainer"
}
const _hoisted_7 = { class: "greyBackgroundText" }
const _hoisted_8 = {
  key: 3,
  class: "greyBackgroundContainer"
}
const _hoisted_9 = { class: "greyBackgroundText" }
const _hoisted_10 = {
  key: 5,
  class: "greyBackgroundContainer"
}
const _hoisted_11 = { class: "greyBackgroundForm" }
const _hoisted_12 = { class: "formText" }
const _hoisted_13 = { class: "formText" }
const _hoisted_14 = { class: "formText" }
const _hoisted_15 = {
  key: 7,
  class: "greyBackgroundContainer"
}
const _hoisted_16 = { class: "greyBackgroundForm" }
const _hoisted_17 = { class: "formText" }
const _hoisted_18 = { class: "formText" }
const _hoisted_19 = { class: "formText" }
const _hoisted_20 = {
  key: 9,
  class: "greyBackgroundContainer"
}
const _hoisted_21 = { class: "greyBackgroundText" }
const _hoisted_22 = {
  key: 11,
  class: "greyBackgroundContainer"
}
const _hoisted_23 = { class: "greyBackgroundText" }
const _hoisted_24 = {
  key: 13,
  class: "greyBackgroundContainer"
}
const _hoisted_25 = { class: "greyBackgroundText" }
const _hoisted_26 = {
  key: 15,
  class: "greyBackgroundContainer"
}
const _hoisted_27 = { class: "greyBackgroundText" }
const _hoisted_28 = {
  key: 17,
  class: "greyBackgroundContainer"
}
const _hoisted_29 = { class: "greyBackgroundText" }
const _hoisted_30 = {
  key: 19,
  class: "greyBackgroundContainer"
}
const _hoisted_31 = { class: "greyBackgroundForm" }
const _hoisted_32 = {
  key: 21,
  class: "greyBackgroundContainer"
}
const _hoisted_33 = { class: "greyBackgroundForm" }
const _hoisted_34 = { key: 22 }
const _hoisted_35 = {
  key: 1,
  class: "greyBackgroundContainer"
}
const _hoisted_36 = { class: "greyBackgroundForm" }
const _hoisted_37 = { key: 23 }
const _hoisted_38 = {
  key: 1,
  class: "greyBackgroundContainer"
}
const _hoisted_39 = { class: "greyBackgroundForm" }
const _hoisted_40 = { id: "MajorSituationBodyRight" }
const _hoisted_41 = {
  key: 1,
  id: "majorEmploymentRank"
}
const _hoisted_42 = { class: "majorEmploymentRankGradeContainer" }
const _hoisted_43 = { class: "majorEmploymentRankGrade" }
const _hoisted_44 = {
  key: 2,
  id: "majorEmploymentRankMoreContainer"
}
const _hoisted_45 = {
  key: 4,
  id: "majorTargetRank"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "•", -1))
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { id: "MajorSituationFooter" }
const _hoisted_49 = { id: "instructions" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "instructionsTitle" }, "系统使用说明", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本查询系统数据来源于教育部官网、阳光高考、各省教育考试院、各院校官网及招生就业网、软科官网、中国科教评价网、麦可思研究院等，数据仅供参考，具体数据请以学校官网或考试院最新公布为准。", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本站数据未经授权严禁转载，违者将依法追究责任。", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "如对本系统或相关服务有任何疑问，可拨打电话400-018-0810反馈于我们。", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "qrCodeContainer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qrCodeItem" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))

import RightTitle from '@/components/collegeSituation/RightTitle.vue'
  import LeftTitle from '@/components/collegeSituation/LeftTitle.vue'
  import {useRoute,useRouter} from 'vue-router'
  import {ref, reactive,nextTick,onMounted,computed} from 'vue'
  import {
    baseURL,
    downloadMajorTargetRank,
    getMajorInfo,
    getMajorTargetRank, majorsGetMajorRanks, majorsGetMajorRanksType
  } from "@/network/axios";
  import {log} from "echarts/types/src/util/log";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMajorSituation',
  props: ['majorInfo','majorInfo2','firstStr'],
  setup(__props) {

const props = __props;

  let route =useRoute();
  let router =useRouter();

  let majorCode:any =route.params.id;



  
  //firstStr 第一个数字0、1是本科；2、3是职本；4、5是专科

  //如果页面左半部 都没有
  // let noDataImg =ref(false);
  let noDataImg =computed(()=>{
    if (props.majorInfo.advise==''&&props.majorInfo.details==''&&props.majorInfo.famous==''&&props.majorInfo.intruduction==''&&props.majorInfo.masterDir==''&&props.majorInfo.offering==''&&props.majorInfo.orientation==''){
      return true
    }else {
      return false
    }
  });

  let majorRightInfo = reactive({
    majorRanksTypeId: '',
    // majorEmploymentRate: [],
    majorRanksInfo: [],
    majorTargetRank: [],
  });

  //获取软科专业院校排行榜
  majorsGetMajorRanksType('/majors/getMajorRanksType').then((res) => {
    if (res.data.code == 200) {
      //把 软科院校专业排名 的id 给majorRightInfo.majorRanksTypeId
      majorRightInfo.majorRanksTypeId = res.data.data.find(item => item.ranksTypeName == '软科院校专业排名').majorRanksTypeId;
      majorsGetMajorRanks('/majors/getMajorRanks',{
        params:{
          majorId:route.params.id,
          majorRanksTypeId: majorRightInfo.majorRanksTypeId,
        }
      }).then((res)=>{
        if (res.data.code == 200){
          majorRightInfo.majorRanksInfo =[];
          majorRightInfo.majorRanksInfo =res.data.data;
        }
      })
    }
  });

  //点击软科专业院校排行榜 查看更多 的弹窗
  let getMajorRanksDialog =ref(false);


  // 专业就业率排行榜 前三名颜色
  let bgStyle = (n: number) => {
    if (n == 0) {
      return 'background:#d33336'
    } else if (n == 1) {
      return 'background:#dc6a6c'
    } else if (n == 2) {
      return 'background:#eabcbe'
    }
  };

  //获取专业(类)指标排行榜
  let getMajorGroupRankFileName=()=> {
    let hierarchy:any =ref('');
    if (majorCode[0] == 0 ||majorCode[0] == 1){
      hierarchy.value=1
    }else if (majorCode[0] == 2 ||majorCode[0] == 3){
      hierarchy.value=2
    }else if (majorCode[0] == 4 ||majorCode[0] == 5){
      hierarchy.value=3
    }
    getMajorTargetRank('/majors/getMajorGroupRankFileName',{
      params:{
        hierarchy:hierarchy.value
      }
    }).then((res) => {
      majorRightInfo.majorTargetRank = [];
      majorRightInfo.majorTargetRank = res.data.data
    });
  }
  getMajorGroupRankFileName()

  //下载专业(类)指标排行榜
  let downloadTargetRank = (fileName:any,route:any)=>{
    window.open(baseURL+'/majors/downloadFile?fileName='+fileName+'&route='+route)
    // downloadMajorTargetRank('/majors/downloadFile',{
    //   params:{
    //     fileName:fileName,
    //     route:route,
    //   }
    // }).then((res)=>{
    //   // console.log(res.data)
    //   downloadFile(res.data,fileName)
    // })
  };

  let downloadFile =(data:any,fileName:any)=>{
    if (!data) {
      return
    }
    //创建一个新的对象URL，该对象URL代表bold对象。
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    //给a标签 添加“下载”属性，文件名为：“value”
    link.setAttribute('download', fileName+'.pdf');
    document.body.appendChild(link);
    link.click();
  }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(getMajorRanksDialog),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(getMajorRanksDialog) ? (getMajorRanksDialog).value = $event : getMajorRanksDialog = $event)),
      class: "majorRanksDialog",
      width: "100%",
      "align-center": true,
      "lock-scroll": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(majorRightInfo).majorRanksInfo,
          "align-center": true,
          height: "450",
          class: "majorRanksDialogTable"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { "min-width": "11%" }, {
              default: _withCtx((scope) => [
                (scope.$index+1<4)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tableIndex",
                      style: _normalizeStyle(_unref(bgStyle)(scope.$index))
                    }, _toDisplayString(scope.$index+1), 5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              "min-width": "52%",
              label: "大学名称",
              "show-overflow-tooltip": true,
              align: "center",
              prop: "collegeName"
            }),
            _createVNode(_component_el_table_column, {
              "min-width": "37%",
              label: "专业等级",
              "show-overflow-tooltip": true,
              align: "center",
              prop: "collegeMajorGrade"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(scope.row.collegeMajorGrade), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(props).majorInfo.intruduction!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 0,
                title: "专业介绍"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.intruduction!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(props).majorInfo.intruduction), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.offering!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 2,
                title: "开设课程"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.offering!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(props).majorInfo.offering), 1)
              ]))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo.advise.limitaion =='' && _unref(props).majorInfo.advise.foundation ==''&& _unref(props).majorInfo.advise.demand =='') )
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 4,
                title: "选择建议"
              }))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo.advise.limitaion =='' && _unref(props).majorInfo.advise.foundation ==''&& _unref(props).majorInfo.advise.demand =='') )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      (_unref(props).majorInfo.advise.limitaion!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("专业限制")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(props).majorInfo.advise.limitaion), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo.advise.foundation !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("学科基础")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(props).majorInfo.advise.foundation), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo.advise.demand !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("选考要求")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(props).majorInfo.advise.demand), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo.masterDir.firstLevel ==''&&_unref(props).majorInfo.masterDir.MdName ==''))
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 6,
                title: "升学方向"
              }))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo.masterDir.firstLevel ==''&&_unref(props).majorInfo.masterDir.MdName ==''))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      (_unref(props).majorInfo.masterDir.firstLevel!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("研究生一级学科")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(props).majorInfo.masterDir.firstLevel), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo.masterDir.MdName!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("硕博名称")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(props).majorInfo.masterDir.MdName), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo.masterDir.majorsConnection !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("接续专业")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(props).majorInfo.masterDir.majorsConnection), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.orientation!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 8,
                title: "就业方向"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.orientation!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(props).majorInfo.orientation), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.famous!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 10,
                title: "社会名人"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo.famous!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(props).majorInfo.famous), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.careerOriented!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 12,
                title: "职业面向"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.careerOriented!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(props).majorInfo2.careerOriented), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.cultivateTarget!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 14,
                title: "培养目标定位"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.cultivateTarget!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(props).majorInfo2.cultivateTarget), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.mainProfessional!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 16,
                title: "主要专业能力要求"
              }))
            : _createCommentVNode("", true),
          (_unref(props).majorInfo2.mainProfessional!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(props).majorInfo2.mainProfessional), 1)
              ]))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo2.mainClass.basicCourses =='' && _unref(props).majorInfo2.mainClass.coreCourses ==''&& _unref(props).majorInfo2.mainClass.internshipTraining =='') )
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 18,
                title: "主要专业课程与实习实训"
              }))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo2.mainClass.basicCourses =='' && _unref(props).majorInfo2.mainClass.coreCourses ==''&& _unref(props).majorInfo2.mainClass.internshipTraining =='') )
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      (_unref(props).majorInfo2.mainClass.basicCourses!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("专业基础课程")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.mainClass.basicCourses), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo2.mainClass.coreCourses !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("专科核心课程")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.mainClass.coreCourses), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo2.mainClass.internshipTraining !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("实习实训")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.mainClass.internshipTraining), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo2.careerCertificateExample.professionalSkillLevel =='' && _unref(props).majorInfo2.careerCertificateExample.qualificationCertificate =='') )
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 20,
                title: "职业类证书举例"
              }))
            : _createCommentVNode("", true),
          (!(_unref(props).majorInfo2.careerCertificateExample.professionalSkillLevel =='' && _unref(props).majorInfo2.careerCertificateExample.qualificationCertificate =='') )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      (_unref(props).majorInfo2.careerCertificateExample.qualificationCertificate!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("职业资格证书")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.careerCertificateExample.qualificationCertificate), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(props).majorInfo2.careerCertificateExample.professionalSkillLevel !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, { type: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("职业技能等级证书")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.careerCertificateExample.professionalSkillLevel), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(props).firstStr ==2 ||_unref(props).firstStr ==3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (!(_unref(props).majorInfo2.continuationMajor.first =='' && _unref(props).majorInfo2.continuationMajor.second =='') )
                  ? (_openBlock(), _createBlock(LeftTitle, {
                      key: 0,
                      title: "接续专业举例"
                    }))
                  : _createCommentVNode("", true),
                (!(_unref(props).majorInfo2.continuationMajor.first =='' && _unref(props).majorInfo2.continuationMajor.second =='') )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_form, null, {
                          default: _withCtx(() => [
                            (_unref(props).majorInfo2.continuationMajor.second!='')
                              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_tag, { type: "danger" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("学术型博士二级学科")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.continuationMajor.second), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(props).majorInfo2.continuationMajor.first !='')
                              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_tag, { type: "danger" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("专业学位硕士")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.continuationMajor.first), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(props).firstStr ==4 ||_unref(props).firstStr ==5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (!(_unref(props).majorInfo2.continuationMajor.first =='' && _unref(props).majorInfo2.continuationMajor.second =='') )
                  ? (_openBlock(), _createBlock(LeftTitle, {
                      key: 0,
                      title: "接续专业举例"
                    }))
                  : _createCommentVNode("", true),
                (!(_unref(props).majorInfo2.continuationMajor.first =='' && _unref(props).majorInfo2.continuationMajor.second =='') )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_el_form, null, {
                          default: _withCtx(() => [
                            (_unref(props).majorInfo2.continuationMajor.second!='')
                              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_tag, { type: "danger" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("高职本科")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.continuationMajor.first), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(props).majorInfo2.continuationMajor.first !='')
                              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_tag, { type: "danger" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("普通本科")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_unref(props).majorInfo2.continuationMajor.second), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_unref(majorRightInfo).majorRanksInfo.length>0)
            ? (_openBlock(), _createBlock(RightTitle, {
                key: 0,
                title: "软科专业院校排行榜"
              }))
            : _createCommentVNode("", true),
          (_unref(majorRightInfo).majorRanksInfo.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_el_table, {
                  data: _unref(majorRightInfo).majorRanksInfo.slice(0,10)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { "min-width": "11%" }, {
                      default: _withCtx((scope) => [
                        (scope.$index+1<4)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "tableIndex",
                              style: _normalizeStyle(_unref(bgStyle)(scope.$index))
                            }, _toDisplayString(scope.$index+1), 5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      "min-width": "52%",
                      label: "专业名称",
                      "show-overflow-tooltip": true,
                      align: "center",
                      prop: "collegeName"
                    }),
                    _createVNode(_component_el_table_column, {
                      "min-width": "37%",
                      label: "专业等级",
                      "show-overflow-tooltip": true,
                      align: "center",
                      prop: "collegeMajorGrade"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, _toDisplayString(scope.row.collegeMajorGrade), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true),
          (_unref(majorRightInfo).majorRanksInfo.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("a", {
                  href: "###",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(getMajorRanksDialog) //@ts-ignore
 ? getMajorRanksDialog.value = true : getMajorRanksDialog =true))
                }, "查看更多>>")
              ]))
            : _createCommentVNode("", true),
          (_unref(majorRightInfo).majorTargetRank.length>0)
            ? (_openBlock(), _createBlock(RightTitle, {
                key: 3,
                title: "专业(类)指标排行榜"
              }))
            : _createCommentVNode("", true),
          (_unref(majorRightInfo).majorTargetRank.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createVNode(_component_el_form, {
                  "label-position": "right",
                  "label-width": "30px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(majorRightInfo).majorTargetRank, (item) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, null, {
                        label: _withCtx(() => [
                          _hoisted_46
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "formText",
                            onClick: ($event: any) => (_unref(downloadTargetRank)(item.fileName,item.route))
                          }, _toDisplayString(item.fileName), 9, _hoisted_47)
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "1." }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "2." }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "3." }, {
                default: _withCtx(() => [
                  _hoisted_53
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_54
    ])
  ], 64))
}
}

})